module.exports = __webpack_public_path__ + "img/shivam.d6b8882f.png";